export default "__VITE_ASSET__C0VpJa4B__"